define('threadsView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'threadsListView',
  'threadsMenuView',
  'template!threadsView',
  'entities/threads'
], function (
  App,
  Module,
  Marionette,
  _,
  ListView,
  MenuView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'threads-view',

    regions: {
      listRegion: '.list-region',
      menuRegion: '.menu-region',
      threadRegion: '.thread-region'
    },

    onRender: function() {
      this.listView = new ListView({
        parentView: this
      });
      this.getRegion('listRegion').show(this.listView);

      this.menuView = new MenuView({
        from: this.options.from,
        folder: this.options.folder,
        listView: this.listView
      });
      this.getRegion('menuRegion').show(this.menuView);
      this.menuView.on('folder:selected', _.bind(function (id, clearSearch) {
        if(clearSearch === true) {
          this.listView.searchView.clear();
          this.listView.threadsView.clearSearch();
        }
        this.listView.threadsView.setFolder(id);
      }, this));
    }
  });
});

